import { IMapSettings } from 'views/components/Video/MapComponent';

import { securePostRequest, secureRequest } from 'utils/request';

export const filterVehiclesByPolygon = (polygon: any) =>
  securePostRequest(`api/v1/map/region`)(polygon);

interface IPeriodFilters {
  branch?: number[];
  depot?: number[];
  route_id?: number[];
  routeType?: string[];
  depotNumber?: number[];
  brand_model?: string[];
}

export interface IVehiclesParams {
  start: string;
  end: string;
  filters: IPeriodFilters;
  skipCount: number;
  recordCount: number;
  sort_field: string;
}

export const getVehiclesByPeriod = (params: IVehiclesParams, path: string) =>
  securePostRequest(`api/v1/map/vehicles/period`)(params);

interface IParams {
  vehicleId: number;
  start: string;
  end: string;
};

interface IHistoricalParams extends IParams {
  includedRoute?: boolean;
  includedIncidents?: boolean;
}


export const saveMapSettings = (settings: { coords: IMapSettings }) =>
  securePostRequest(`api/v1/auth/coord`)(settings);

export const getVehicleByDepotNumber = (number: string) =>
  securePostRequest(`api/v1/map/vehicles?number=${number}`)({});

export const getHistoricalData = (params: IHistoricalParams) => {
  const urlParams = new URLSearchParams();
  Object.entries(params).forEach((paramArr)=> urlParams.append(paramArr[0], paramArr[1]));
  const queryUrl = 'api/v1/map/telematic/historical-data?' + urlParams.toString();
  return secureRequest(queryUrl);
}